import { createSelector } from "reselect";
const selector = (state) => state.emailTemplates;

export default createSelector([selector], (data) => data);